import React from "react";
import "./index.less";
import { ChatLayoutContainer } from "../ChatLayoutContainer";
import { useTranslate } from "@obsbot/remo-i18n";
import { AvatarComProps, ContactList, ListEmpty } from "remo-components";
import { RouteNameType, usePushHistory } from "../../utils/routes";
import { useFriendStore } from "@obsbot/remo-stores";
const AllFriendsPage = (): React.ReactElement => {
    const t = useTranslate();
    const pushHistory = usePushHistory();
    const { friendList } = useFriendStore();

    const onClick = (path: string, info?: AvatarComProps): void => {
        if (info) {
            pushHistory(path as RouteNameType, {
                id: info?.userID,
                name: info.userName?.toString().trim() || info.userID,
            });
        }
    };

    return (
        <ChatLayoutContainer>
            {friendList.length > 0 ? (
                <div className="all-friends-page">
                    <div className="friend-page-title">
                        {t("chat.all", {
                            user: "  " + friendList?.length + " " + t("chat.people"),
                        })}
                    </div>
                    <ContactList modeType="list-all" onClick={onClick} />
                </div>
            ) : (
                <div className="all-friends-page-empty">
                    <ListEmpty modeType="list-all" />
                </div>
            )}
        </ChatLayoutContainer>
    );
};

export default AllFriendsPage;
